module.exports = __webpack_public_path__ + "img/signUpBtnBg1.e8fa6a7a.png";